<template lang='pug'>
  .turing-complete
    website-spacing.whitespace
      v-row(justify='center')
        v-col
          .display-2.pa-4.grey--text.text--darken-2.text-center Embrace The Power of Code
          .headline.pa-4.grey--text.text--darken-2.text-center We embrace the power of code rather than attempting a “codeless” or “low-code” solution. Using a Turing-Complete language allows for far more flexibility, power, and easier maintenance in the long run.
      v-row(justify='center' align='center')
        v-col(cols='5')
          v-img(src='https://assets.bionicmetrics.com/bionic/turingCode.png').image-left
        v-col(cols='2' align='center')
          font-awesome-icon(icon='greater-than').greater-than
        v-col(cols='5')
          v-img(src='https://assets.bionicmetrics.com/bionic/turingComplete.png')
</template>

<script>
import WebsiteSpacing from './WebsiteSpacing';

export default {
  name: 'TuringComplete',
  components: {WebsiteSpacing},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .turing-complete {
    background-color: #ffffff;
  }

  .greater-than {
    font-size: 10vmin;
  }

  .image-left {
    position: relative;
    transform: rotate3d(.5, .866, 0, 15deg) rotateZ(-1deg);
    box-shadow: -27.1px 62.5px 125px -25px rgba(50, 50, 93, .5), -16.2px 37.5px 75px -37.5px rgba(0, 0, 0, .6);
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
  }

  .whitespace {
    padding-top: 10vh;
    padding-bottom: 10vh;
  }
</style>
